module.exports = __webpack_public_path__ + "static/img/wheel_of_services.2f4ecc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/buyer-listing-details-as-pdf/assets/wheel_of_services.svg
// module id = nj8O
// module chunks = 0